import { defaultMobileCell1Id } from '~/services/layout/layout';

export type VideoDetailCellPluginConfigurationIds = {
  mobileCellId: string;
  tabletCellId: string;
  desktopCellId: string;
  largeDesktopCellId: string;
};

export function getVideoDetailCellPluginConfigurationIds(
  styles: Record<string, any> = {}
): VideoDetailCellPluginConfigurationIds {
  const mobileCellId: string =
    styles?.video_detail_cell_plugin_configuration_id_mobile ||
    defaultMobileCell1Id;

  const tabletCellId: string =
    styles?.video_detail_cell_plugin_configuration_id_tablet || mobileCellId;

  const desktopCellId: string =
    styles?.video_detail_cell_plugin_configuration_id_desktop || tabletCellId;

  const largeDesktopCellId: string =
    styles?.video_detail_cell_plugin_configuration_id_large_desktop ||
    desktopCellId;

  return {
    mobileCellId,
    tabletCellId,
    desktopCellId,
    largeDesktopCellId,
  };
}
